
export default {
  props: {
    value: {
      required: true
    },
    placeholder: {type: String, default: ''},
    disabled: {type: Boolean, default: false},
  },

  data() {
    return {
      model: {},
    }
  },

  watch: {
    model() {
      this.$emit('input', this.model);
    },
    value() {
      this.model = this.value;
    }
  },
  created() {
    this.model = this.value;
  }
};